import { getStrapiMedia } from "@repo/lib/utils";
import { MotionContainer } from "@repo/ui";
import Image from "next/image";
const CeoMessage = ({
  data
}) => {
  const {
    title,
    media,
    subtitle,
    description,
    enable
  } = data;
  if (!enable) return;
  return <section className="bg-supportiveDarkYellow px-4 py-16 md:px-0" data-sentry-component="CeoMessage" data-sentry-source-file="CeoMessage.jsx">
      <div className="mx-auto md:max-w-screen-xl">
        <div className="mx-auto max-w-2xl items-center justify-center text-center md:flex md:space-x-4 md:text-left rtl:space-x-reverse">
          {media?.file?.url && <MotionContainer delay={0.4}>
              <span className="block min-w-[104px]">
                <Image src={getStrapiMedia(media?.file?.url)} alt={media?.file?.alternativeText} width={media?.file?.width} height={media?.file?.height} className="mx-auto" />
              </span>
            </MotionContainer>}

          <div className="pt-5 md:pt-0">
            {title && <MotionContainer delay={0.2}>
                <h4 className="text-lightYellow pb-3 text-xs font-medium md:text-start md:text-base">
                  {title}
                </h4>
              </MotionContainer>}

            {subtitle && <MotionContainer delay={0.3}>
                <p className="font-heading rtl:font-arabic text-2xl font-medium md:text-start md:text-[32px] md:leading-[44px]">
                  {subtitle}
                </p>
              </MotionContainer>}
          </div>
        </div>
        {description && <MotionContainer delay={0.5}>
            <p className="font-heading rtl:font-arabic mx-auto max-w-4xl pt-5 text-center text-sm">
              {description}
            </p>
          </MotionContainer>}
      </div>
    </section>;
};
export default CeoMessage;